import * as React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
// components
import Search from 'components/UI/PageSearch'
import AccountsTable from './components/Table'
import MainLayoutContainer from 'containers/MainLayout'
import NavigationSidebar from 'components/UI/NavigationSidebar'
// views
import { Container } from '@mui/material'
import { CreateAccountButton } from 'components/CTAs/index'
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// context
import { AccountsPageContext } from 'containers/Accounts/layers/API'
// utils
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'

const Accounts: React.FC = () => {
  const { isLoading } = React.useContext(AccountsPageContext)

  return (
    <>
      <Helmet>
        <title>Skefto - Account Settings</title>
      </Helmet>
      <MainLayoutContainer
        isLoading={isLoading}
        CTA={
          <>
            <Search name={'name'} />
            <CreateAccountButton />
          </>
        }>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <Container maxWidth={false}>
            <AccountsTable />
          </Container>
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>
    </>
  )
}

export default Accounts
